<template>
  <div>
    <v-toolbar flat dense>
      <v-text-field
        v-model="filter"
        label=""
        :append-icon="filter ? '' : 'mdi-filter'"
        clearable
        clear-icon="mdi-filter-remove"
        class="search"
        @focus="filterFocused = true"
        @blur="filterFocused = false"
      ></v-text-field>
      <v-btn v-show="!filterFocused" text icon @click="onNewFolderOnRoot()" :title="$t('NAVI_NEW_FOLDER_TT')"><v-icon>mdi-folder-plus-outline</v-icon></v-btn>
      <v-btn v-show="!filterFocused" text icon @click="onNewCampaignOnRoot()" :title="$t('NAVI_NEW_CAMPAIGN_TT')"><v-icon>mdi-bullhorn-outline</v-icon></v-btn>
      <v-btn v-show="!filterFocused" text icon @click="onNewMailingOnRoot()" :title="$t('NAVI_NEW_MAILING_TT')"><v-icon>mdi-email-plus-outline</v-icon></v-btn>
    </v-toolbar>


    <v-treeview
      v-model="tree"
      :open="open"
      hoverable
      activatable
      :items="dragItems"
      item-key="key"
      item-text="label"
      :active="active"
      open-on-click-
      return-object
      @update:open="onUpdateOpen"
      @update:active="onUpdateActive"
      :search="filter"
    >
      <template v-slot:prepend="{ item, open }">
        <v-icon :color="item.datatype === 'campaign' && !item.old ? 'warning' : ''">
          {{ item.icon ? item.icon : (open ? 'mdi-folder-open' : 'mdi-folder') }}
        </v-icon>
      </template>

      <template v-slot:label="{ item }">

        <draggable :list="dragItems" group="dndmailing" :id="item.key" :data-parent="item.parentKey" @start="checkStart" @end="checkEnd"    >

          <!-- <v-tooltip right>
            <template v-slot:activator="{ on, attrs }"> -->

              <div
                :class="{ 'grey--text text--darken-1': !item.own }"
                @click.prevent="onItemClick(item)"
                @dblclick.prevent="onItemDblClick(item)"
                style="user-select: none;"
              >
                <!-- v-bind="attrs"
                v-on="on" -->
              {{ item.label }}{{ item.children ? ` (${item.children.length})` : '' }}
              </div>

              <!-- <v-btn
                color="primary"
                dark

              >
                Right
              </v-btn> -->
            <!-- </template>
            <span>{{ item.label }}{{ item.children ? ` (${item.children.length})` : '' }}</span>
          </v-tooltip> -->

        </draggable>

      </template>
      <template v-slot:append="{ item }">
        <v-icon @click="openMenu($event, item)">mdi-dots-vertical</v-icon>
      </template>
    </v-treeview>
    <v-card v-if="!items.length">
      <v-card-text class="grey lighten-3">{{ $t('NAVI_MAILINGS_NO_RESULTS') }}</v-card-text>
    </v-card>
    <v-menu
      v-model="contextMenuVisible"
      :position-x="x"
      :position-y="y"
      absolute
      offset-y
    >
      <v-list>
        <template
          v-for="(item, idx) in contextMenuComputed"
        >
          <v-divider
            v-if="item.divider"
            :inset="item.inset"
            :key="idx"
          ></v-divider>
          <v-list-item
            v-else
            :key="idx"
            :color="item.disabled ? 'grey' : ''"
            @click="contextMenuCallback(idx)"
          >
            <v-list-item-title>{{ item.title }}</v-list-item-title>
          </v-list-item>
        </template>
      </v-list>
    </v-menu>

    <Dialog ref="dialog" />
    <NameDlg v-if="showNameFolderDlg" :title="$t('NAVI_OVERLAY_HEAD_NEW_FOLDER')" label="" @ok="onCreateFolder($event); showNameFolderDlg = false" @cancel="showNameFolderDlg = false" />
    <NameDlg v-if="showRenameFolderDlg" :title="$t('NAVI_OVERLAY_HEAD_RENAME_FOLDER')" label="" :name="valueRenameFolderDlg" @ok="onRenameFolder($event); showRenameFolderDlg = false" @cancel="showRenameFolderDlg = false" />
    <NameDlg v-if="showRenameMailingDlg" :title="$t('NAVI_OVERLAY_HEAD_RENAME_MAILING')" label="" :name="valueRenameMailingDlg" @ok="onRenameMailing($event); showRenameMailingDlg = false" @cancel="showRenameMailingDlg = false" />

  </div>
</template>

<script>
import Vue from 'vue'
import { mapGetters } from 'vuex'

import Mailing from '../services/Mailing'
import Campaign from '../services/Campaign'
import Dialog from './common/Dialog'
import NameDlg from './common/NameDlg'
import Folder from '../services/Folder'
import { dateToISO } from '../helpers/filters';
import draggable from 'vuedraggable'

export default {
  name: 'TreeviewCampaigns',
  components: {
    Dialog,
    NameDlg,
    draggable,
  },
  props: [],
  data() {
    return {
      tree: [],
      open: [],
      filter: '',
      filterFocused: false,
      contextMenuVisible: false,
      x: 0,
      y: 0,
      active: [],
      contextItem: null,
      showNameFolderDlg: false,
      showRenameFolderDlg: false,
      showRenameMailingDlg: false,
      valueRenameFolderDlg: '',
      valueRenameCampaignDlg: '',
      valueRenameMailingDlg: '',
      dragItems: [],
    }
  },
  computed: {
    ...mapGetters([
      'isBusy',
      'user_id',
      'is_admin',
      'getFolders',
      'getCampaigns',
      'getFoldersMap',
      'campaignEntries',
      'selectedCampaignFolder'
    ]),
    contextMenuOwn() {
      const self = this
      return [
        { datatype: 'folder', title: this.$t('NAVI_RENAME_FOLDER_CM'), callback: (item) => { self.valueRenameFolderDlg = item.label; self.showRenameFolderDlg = true } },
        { datatype: 'folder', title: this.$t('NAVI_DELETE_FOLDER_CM'), callback: this.deleteFolder },
        { datatype: 'campaign', title: this.$t('NAVI_EDIT_CAMPAIGN_CM'), callback: 'editCampaign' },
        { datatype: 'campaign', title: this.$t('NAVI_DELETE_CAMPAIGN_CM'), callback: this.deleteFolder },
        { datatype: 'mailing', title: this.$t('NAVI_EDIT_MAILING_CM'), callback: 'editMailing' },
        { datatype: 'mailing', title: this.$t('NAVI_RENAME_MAILING_CM'), callback: (item) => { self.valueRenameMailingDlg = item.label; self.showRenameMailingDlg = true } },
        { datatype: 'mailing', title: this.$t('NAVI_DELETE_MAILING_CM'), callback: 'deleteMailing' },
        { datatype: 'print', title: this.$t('NAVI_EDIT_PRINTMAIL_CM') },
        { datatype: 'print', title: this.$t('NAVI_RENAME_PRINTMAIL_CM') },
        { datatype: 'print', title: this.$t('NAVI_DELETE_PRINTMAIL_CM') },
        { divider: true },
        { title: this.$t('NAVI_NEW_MAILING_CM'), callback: this.onNewMailing },
        // { title: this.$t('NAVI_NEW_PRINTMAIL_CM'), disabled: true },
        // { title: this.$t('NAVI_NEW_CAMPAIGN_CM'), callback: this.onNewCampaign, disabled: true },
        { title: this.$t('NAVI_NEW_FOLDER_CM'), callback: () => { self.showNameFolderDlg = true } },
      ]
    },
    contextMenuOther() {
      return [
        // { datatype: 'folder', title: this.$t('NAVI_RENAME_FOLDER_CM'), callback: 'renameFolder' }, // TODO: should this be available?
        // { datatype: 'folder', title: this.$t('NAVI_DELETE_FOLDER_CM'), callback: this.deleteFolder }, // TODO: should this be available?
        // { datatype: 'campaign', title: this.$t('NAVI_EDIT_CAMPAIGN_CM'), callback: 'editCampaign' },
        // { datatype: 'campaign', title: this.$t('NAVI_DELETE_CAMPAIGN_CM') }, // TODO: should this be available?
        { datatype: 'mailing', title: this.$t('NAVI_EDIT_MAILING_CM'), callback: 'editMailing' }, // TODO: should it be "Open mailing?"
        // { datatype: 'print', title: this.$t('NAVI_EDIT_PRINTMAIL_CM') },
        // { datatype: 'print', title: this.$t('NAVI_RENAME_PRINTMAIL_CM') }, // TODO: should this be available?
        // { datatype: 'print', title: this.$t('NAVI_DELETE_PRINTMAIL_CM') }, // TODO: should this be available?
      ]
    },
    items() {
      const foldersMap = this.getFoldersMap
      const campaignEntries = this.campaignEntries.slice()
      let tree = this.mapRootFoldersAndCampaigns(foldersMap, campaignEntries)
      return tree
    },
    contextMenuComputed() {
      if (!this.contextItem) {
        return
      }
      let contextMenu = this.contextItem.own ? this.contextMenuOwn : this.contextMenuOther
      return contextMenu.filter(a => !a.datatype || !this.contextItem || a.datatype === this.contextItem.datatype)
    },
  },
  watch: {
    items(val) {
      this.dragItems = val
    },
  },
  mounted() {
    this.dragItems = this.items
  },


  methods: {
    compItems (a, b) {
      let res = 0
      if ((res = ('' + a.datatype).localeCompare(b.datatype)) == 0) {
        if ((res = ('' + a.old).localeCompare(b.old)) == 0) {
          res = ('' + a.name).localeCompare(b.name)
        }
      }
      return res
    },

    mapRootFoldersAndCampaigns(folders, campaignEntries) {
      let children = []
      for (const i in folders) {
        let f = folders[i]
        const foundCampaign = this.getCampaigns.find(a => a.campaign_id === f.campaign_id)
        if (!f.parent_id && f.type === '2') {
          f.key = `${f.campaign_id ? 'c' : 'f'}${f.id}`
          f.label = `${f.name}`
          // f.label = `${f.name} (${f.id})`
          f.datatype = f.campaign_id ? 'campaign' : 'folder'
          // f.own = (f.user_id === this.user_id) || this.is_admin
          f.own = true
          f.parent = null
          f.parentKey = null
          f.in_campaign_id = f.campaign_id
          Vue.set(f, 'children', [...this.mapFoldersToFolder(f, folders, campaignEntries), ...this.mapMailingsToFolder(f, campaignEntries)])
          f.icon = f.campaign_id ? 'mdi-bullhorn' : null
          f.old = f.campaign_id && foundCampaign && foundCampaign.end_date ? new Date(dateToISO(foundCampaign.end_date)) - new Date() < 0 : null
          // add folder to root account
          children.push(f)
        }
      }
      // root campaignEntries
      for (const i in campaignEntries) {
        let ce = campaignEntries[i]
        if (!ce.folder_id) {
          // add campaign to root account
          ce.key = `${ce.type === 'print' ? 'p' : 'm'}${ce.id}`
          ce.label = `${ce.name || ce.title}`
          // ce.label = `${ce.name} (${ce.id})`
          ce.datatype = ce.type === 'print' ? 'print' : 'mailing'
          ce.own = (ce.user_id === this.user_id) || this.is_admin
          ce.parent = null
          ce.parentKey = null
          ce.icon = ce.type === 'print' ? 'mdi-file-document-outline' : (ce.status === 'open' ? 'mdi-email-open' : (ce.status==='released'?'mdi-email-check':'mdi-email'))
          children.push(ce)
        }
      }
      children.sort(this.compItems)
      return children || []
    },
    mapFoldersToFolder(folder, folders, campaignEntries) {
      const children = []
      for (const i in folders) {
        let f = folders[i]
        const foundCampaign = this.getCampaigns.find(a => a.campaign_id === f.campaign_id)
        if (f.parent_id === folder.id) {
          // add folder to folder
          f.key = `${f.campaign_id ? 'c' : 'f'}${f.id}`
          f.label = `${f.name}`
          // f.label = `${f.name} (${f.id})`
          f.datatype = f.campaign_id ? 'campaign' : 'folder'
          // f.own = (f.user_id === this.user_id) || this.is_admin
          f.own = true
          f.parent = folder
          f.parentKey = folder.key
          f.in_campaign_id = f.campaign_id? f.campaign_id : folder.in_campaign_id
          Vue.set(f, 'children', [...this.mapFoldersToFolder(f, folders, campaignEntries), ...this.mapMailingsToFolder(f, campaignEntries)])
          f.icon = f.campaign_id ? 'mdi-bullhorn' : null
          f.old = f.campaign_id && this.getCampaigns.length && foundCampaign && foundCampaign.end_date ? new Date(dateToISO(foundCampaign.end_date)) - new Date() < 0 : null
          children.push(f)
        }
      }
      children.sort(this.compItems)
      return children || []
    },
    mapMailingsToFolder(folder, campaignEntries) {
      const children = []
      for (const i in campaignEntries) {
        let ce = campaignEntries[i]
        if (ce.folder_id === folder.id) {
          // add mailing to folder
          ce.key = `${ce.type === 'print' ? 'p' : 'm'}${ce.id}`
          ce.label = `${ce.name || ce.title}`
          // ce.label = `${ce.name} (${ce.id})`
          ce.datatype = ce.type === 'print' ? 'print' : 'mailing'
          ce.own = (ce.user_id === this.user_id) || this.is_admin
          ce.parent = folder
          ce.parentKey = folder.key
          ce.icon = ce.type === 'print' ? 'mdi-file-document-outline' : (ce.status === 'open' ? 'mdi-email-open' : (ce.status==='released'?'mdi-email-check':'mdi-email'))
          children.push(ce)
        }
      }
      children.sort(this.compItems)
      return children || []
    },
    openMenu(e, item) {
      e.stopPropagation()
      this.$store.commit('setSelectedCampaignFolder', item)
      this.contextItem = item
      // this.active = [item.key]
      this.active = [item]
      this.contextMenuVisible = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.contextMenuVisible = true
      })
    },
    contextMenuCallback(idx) {
      if (this.contextMenuComputed[idx].callback) {
        if (typeof this[this.contextMenuComputed[idx].callback] === 'function') {
          this[this.contextMenuComputed[idx].callback](this.contextItem)
        } else
        if (typeof this.contextMenuComputed[idx].callback === 'function') {
          this.contextMenuComputed[idx].callback(this.contextItem)
        }
      }
    },
    onItemClick(item) {
      if (item.datatype === 'campaign' || item.datatype === 'folder') {
        this.open.indexOf(item) > -1 ? this.open.splice(this.open.indexOf(item), 1) : this.open.push(item)
      }
      this.$store.commit('setSelectedCampaignFolder', item)
    },
    onItemDblClick(item) {
      if (item.datatype === 'campaign') {
        this.open.indexOf(item) > -1 ? this.open.splice(this.open.indexOf(item), 1) : this.open.push(item) // keep item open/closed (as if was single click) when is edited
        this.editCampaign(item)
      }
      if (item.datatype === 'mailing' || item.datatype === 'print') {
        this.open.indexOf(item) > -1 ? this.open.splice(this.open.indexOf(item), 1) : this.open.push(item) // keep item open/closed (as if was single click) when is edited
        this.editMailing(item)
      }
      if (item.datatype === 'search') {
        this.runSearch(item)
      }
      if (item.datatype === 'group') {
        this.runGroup(item)
      }
    },
    onNewFolderOnRoot() {
      this.$store.commit('setSelectedCampaignFolder', null)
      this.showNameFolderDlg = true
    },
    onCreateFolder(name) {
      if(!name || !name.trim().length) {
        this.$store.commit('showMessage', {color: 'red', title: this.$t('NAVI_NEW_FOLDER_TT'), content: 'The folder name should not be empty!'})
        return
      }
      const folder = this.selectedCampaignFolder ?
        ( this.selectedCampaignFolder.datatype === 'folder' ||
          this.selectedCampaignFolder.datatype === 'campaign') ? this.selectedCampaignFolder : this.selectedCampaignFolder.parent : null
      new Folder(this.$api).create(name, 2, folder)
        .then(() => {
          new Folder(this.$api).list()
      })
    },
    onRenameFolder(name) {
      if (this.active && this.active.length) {
        new Folder(this.$api).rename(this.active[0].id, name)
        .then(() => {
          new Folder(this.$api).list()
        })
      }
    },
    deleteFolder(item) {
      if (item.children.length) {
        this.$refs.dialog.show({
          type: '',
          title: this.$t('GENERIC_DELETE_ALERT_TITLE'),
          message: this.$t('NAVI_FOLDER_WITH_CHILDREN'),
          buttons: [
            {
              label: this.$t('GENERIC_DELETE'),
              close: true,
              danger: true,
              callback: () => {
                new Folder(this.$api).delete(item.id)
                .then(() => {
                  new Folder(this.$api).list()
                })
              }
            },
            {
              label: this.$t('GENERIC_CANCEL'),
              close: true,
            },
          ]
        })
      } else {
        new Folder(this.$api).delete(item.id)
        .then(() => {
          new Folder(this.$api).list()
        })
      }
    },
    onNewCampaignOnRoot() {
      this.$store.commit('setSelectedCampaignFolder', null)
      this.onNewCampaign();
    },
    onNewCampaign() {
      if (this.selectedCampaignFolder && this.inCampaign(this.selectedCampaignFolder)) {
        this.$store.commit('showMessage', {title: '', color: 'orange', content: this.$t('NAVI_NODROP_CAMPAIGN')})
      } else {
        this.$router.push({ name: 'campaign', params: { id: 'new' }, hash: this.getNewHash()})
      }
    },
    editCampaign(item) {
      this.$router.push({ name: 'campaign', params: { id: item.campaign_id }, hash: this.getNewHash()})
    },
    onNewMailingOnRoot() {
      this.$store.commit('setSelectedCampaignFolder', null)
      this.onNewMailing();
    },
    onNewMailing() {
      this.$router.push({ name: 'mailing', params: {id: 'new'}, hash: this.getNewHash()})
    },
    editMailing(item) {
      this.$router.push({ name: 'mailing', params: { id: item.id, title: item.label }, hash: this.getNewHash()})
    },
    onRenameMailing(name) {
      if (this.active && this.active.length) {
        new Mailing(this.$api).rename(this.active[0].id, name)
        .then(() => {
          new Campaign(this.$api).list_entries()
        })
      }
    },
    deleteMailing(item) {
      this.$refs.dialog.show({
        type: '',
        title: this.$t('GENERIC_DELETE_ALERT_TITLE'),
        message: this.$t('NAVI_CONFIRM_DELETE_MAILING', [item.label]),
        buttons: [
          {
            label: this.$t('GENERIC_DELETE'),
            close: true,
            danger: true,
            callback: () => {
              new Mailing(this.$api).delete(item.id)
              .then(() => {
                new Campaign(this.$api).list_entries()
              })
            }
          },
          {
            label: this.$t('GENERIC_CANCEL'),
            close: true,
          },
        ]
      })
    },
    onUpdateOpen(val) {
      this.open = val
    },
    onUpdateActive(val) {
      this.active = val
    },
    getNewHash() {
      const dt = new Date()
      return '##'+ (dt.getTime()*1000 + dt.getMilliseconds())
    },
    findTreeItem (items, key) {
        if (!items) {
            return;
        }
        for (var i = 0; i < items.length; i++) {
            var item = items[i];
            // Test current object
            if (item.key === key) {
                return item;
            }
            // Test children recursively
            const child = this.findTreeItem(item.children, key);
            if (child) {
              return child;
            }
        }
    },
    checkStart (evt) {
      this.active = [];
      this.active.push(this.findTreeItem(this.dragItems, evt.from.id))
    },
    checkEnd (evt) {
      var itemSelected = this.active[0];
      var fromParent = itemSelected.parentKey ? this.findTreeItem(this.dragItems, itemSelected.parentKey) : null;
      var toParent = this.findTreeItem(this.dragItems, evt.to.id);
      var objFrom = fromParent ? fromParent.children : this.dragItems;

      // if (!itemSelected.own || (itemSelected.datatype == 'mailing' && itemSelected.status == 'closed')) {
      if (!itemSelected.own) { // allow moving for closed mailings also
        return false
      }
      if (!toParent.children) {
        toParent = toParent.parent
      }
      if (toParent) {
        if (toParent.key == itemSelected.key || toParent.key === itemSelected.parentKey) {
          // --- DO NOTHING ---
        } else if (!this.testIsParent(itemSelected, toParent)) {
          if (itemSelected.children) { // FOLDER / CAMPAIGN
            if (this.inCampaign(toParent) && this.hasCampaign(itemSelected)) {
              this.$store.commit('showMessage', {title: '', color: 'orange', content: this.$t('NAVI_NODROP_CAMPAIGN')})
              return false
            }
            new Folder(this.$api).update(itemSelected.id, toParent.id)
              .then(res => {
                console.log('MOVED Folder:', res)
                objFrom.splice(objFrom.indexOf(itemSelected), 1)
                itemSelected.parentKey = toParent.key
                itemSelected.parent = toParent
                toParent.children.push(itemSelected)
                toParent.children.sort(this.compItems) // sort by FullName
              })
          } else { // MAILING
            new Mailing(this.$api).move(itemSelected.id, toParent.id)
              .then(res => {
                console.log('MOVED Mailing:', res)
                objFrom.splice(objFrom.indexOf(itemSelected), 1)
                itemSelected.parentKey = toParent.key
                itemSelected.parent = toParent
                toParent.children.push(itemSelected)
                toParent.children.sort(this.compItems) // sort by FullName
                this.$router.push({ name: 'mailing', params: { id: itemSelected.id, title: itemSelected.label }, hash: this.getNewHash()})
              })
          }
        }
      } else if (itemSelected.parent) {
        if (itemSelected.children) { // FOLDER / CAMPAIGN
          new Folder(this.$api).update(itemSelected.id, 0)
            .then(res => {
              console.log('MOVED Folder:', res)
              objFrom.splice(objFrom.indexOf(itemSelected), 1)
              itemSelected.parentKey = null
              itemSelected.parent = null
              this.dragItems.push(itemSelected)
              this.dragItems.sort(this.compItems)
            })
        } else { // MAILING
          new Mailing(this.$api).move(itemSelected.id, 0)
            .then(res => {
              console.log('MOVED Mailing:', res)
              objFrom.splice(objFrom.indexOf(itemSelected), 1)
              itemSelected.parentKey = null
              itemSelected.parent = null
              this.dragItems.push(itemSelected)
              this.dragItems.sort(this.compItems)
            })
        }
      }
      return false;
    },
    inCampaign(e) { return !e ? false : e.datatype == 'campaign' ? true : this.inCampaign(e.parent) },
    hasCampaign(e) {
      if (e) {
        if (e.datatype == 'campaign') {
          return true
        } else if (e.children) {
          if (e.children.find(child => this.hasCampaign(child))) {
            return true
          }
        }
      }
      return false
    },
    testIsParent(itemSelected, toParent) {
      if (toParent.parentKey === itemSelected.key) {
        return true
      } else if (toParent.parent) {
        return this.testIsParent(itemSelected, toParent.parent)
      }
      return false
    },
  },
}
</script>

<style scoped lang="scss">
.v-btn {
  margin: 0;
}
.v-toolbar {
  .v-toolbar__content {
    padding: 0 12px;
  }
}
.v-treeview {
  .v-treeview-node {
    .v-icon--link.mdi-dots-vertical {
      opacity: 0;
      transition: opacity 0s;
      // fix menu dots for longer labels
      position: absolute;
      right: 0;
      background: rgba(206, 215, 201, 0.9);
    }
  }
  .v-treeview-node__children .v-treeview-node {
    margin-left: 11px;
  }
  .v-treeview-node__children .v-treeview-node--leaf {
    margin-left: 35px;
  }
  .v-treeview-node.v-treeview-node--active > .v-treeview-node__root,
  .v-treeview-node .v-treeview-node__root:hover {
    .v-icon--link.mdi-dots-vertical {
      opacity: 1;
    }
  }
  .v-treeview-node__label {
    margin-right: 6px;
  }
  @media screen and (min-width: 1025px) {
    .v-treeview-node__root {
      height: 24px;
      min-height: 24px;
    }
    .v-icon {
      font-size: 16px;
    }
    .v-treeview-node__label {
      // font-size: 0.8rem;
      font-size: 1rem; // CR
      margin-right: 6px;
    }
  }
}
.v-list {
  @media screen and (min-width: 1025px) {
    .v-list__tile {
      font-size: 12px;
      height: 24px;
    }
  }
}
</style>
